import { ChangeDetectionStrategy, Component, Inject, Input, OnDestroy } from '@angular/core';
import { InteractionAction, TextbookClient } from '@textbook-api-client';
import { TextbookActionBase } from '../@base/textbook-action-base.model';
import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../external/providers/textbook-actions-handler';
import { DomSanitizer } from '@angular/platform-browser';
import { GroupInfo } from '../../models/group-info';
import { filter, first, map } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';

@Component({
  selector: 'txtb-interaction',
  templateUrl: './interaction.component.html',
  styleUrls: ['./interaction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InteractionComponent extends TextbookActionBase<InteractionAction> implements OnDestroy {
  @Input() groupInfo!: GroupInfo;

  get action(): InteractionAction {
    return this._action;
  }
  @Input('action') set action(action: InteractionAction) {
    this._action = action;
    const interactionResourceId = this.getInteractionResourceId(action);
    this.interactionResourceIdBS.getValue() !== interactionResourceId && this.iframeLoadedBS.next(false);
    this.interactionResourceIdBS.next(interactionResourceId);
  }

  private readonly interactionResourceIdBS = new BehaviorSubject<string>('');
  private readonly iframeLoadedBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly iframeLoaded$: Observable<boolean> = this.iframeLoadedBS.asObservable();

  readonly link$ = combineLatest([this.textbookActionsHandler.isReadonlyMode$.pipe(first()), this.interactionResourceIdBS.asObservable()]).pipe(
    filter(([_, interactionResourceId]) => interactionResourceId?.length > 0),
    map(([readonly, interactionResourceId]) => {
      const assetUrl = !readonly ? this.api.getInteractionAssetUrl$(interactionResourceId) : '';
      return this.domSanitizer.bypassSecurityTrustResourceUrl(assetUrl);
    })
  );

  constructor(
    private api: TextbookClient,
    @Inject(TextbookActionsHandlerToken) private textbookActionsHandler: TextbookActionsHandler,
    private domSanitizer: DomSanitizer
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.interactionResourceIdBS.complete();
    this.iframeLoadedBS.complete();
  }

  iframeLoaded(isLoaded: boolean): void {
    this.iframeLoadedBS.next(isLoaded);
  }

  private getInteractionResourceId(action: InteractionAction): string {
    const arr = action?.meta?.url.split('/');
    const interactionResourceId = arr[arr.length - 2];
    return interactionResourceId;
  }
}
